import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import keycode from 'keycode';
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table/index';
import Toolbar from 'material-ui/Toolbar/index';
import Typography from 'material-ui/Typography/index';
import Paper from 'material-ui/Paper/index';
import Checkbox from 'material-ui/Checkbox/index';
import IconButton from 'material-ui/IconButton/index';
import Tooltip from 'material-ui/Tooltip/index';
import DeleteIcon from 'material-ui-icons/Delete';
import FilterListIcon from 'material-ui-icons/FilterList';
import Button from 'material-ui/Button';

let counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return {id: counter, name, calories, fat, carbs, protein};
}

const sampleData = [
    {id: 'name', numeric: false, disablePadding: true, label: 'Dessert (100g serving)'},
    {id: 'calories', numeric: true, disablePadding: false, label: 'Calories'},
    {id: 'fat', numeric: true, disablePadding: false, label: 'Fat (g)'},
    {id: 'carbs', numeric: true, disablePadding: false, label: 'Carbs (g)'},
    {id: 'protein', numeric: true, disablePadding: false, label: 'Protein (g)'},
];

class DataTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {onSelectAllClick, order, orderBy, numSelected, rowCount, columnData, enableSelect} = this.props;

        return (
            <TableHead>
                <TableRow>
                    {enableSelect &&
                    <TableCell padding="checkbox">
                        <Checkbox
                            indeterminate={numSelected > 0 && numSelected < rowCount}
                            checked={numSelected === rowCount}
                            onChange={onSelectAllClick}
                        />
                    </TableCell>
                    }
                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                numeric={column.numeric}
                                padding={column.disablePadding ? 'none' : 'default'}
                                className='text-center'
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

let DataTableToolbar = props => {
    const {numSelected} = props;

    return (
        <Toolbar
            className={classNames("table-header", {
                ["highlight-light"]: numSelected > 0,
            })}
        >
            <div className="title">
                {numSelected > 0 ? (
                    <Typography type="subheading">{numSelected} selected</Typography>
                ) : (
                    <Typography type="title">Nutrition</Typography>
                )}
            </div>
            <div className="spacer"/>
            <div className="actions">
                {numSelected > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                ) : (
                    <Tooltip title="Filter list">
                        <IconButton aria-label="Filter list">
                            <FilterListIcon/>
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

DataTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class DataTable extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));


        this.setState({data, order, orderBy});
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({selected: this.state.data.map(n => n.id)});
            return;
        }
        this.setState({selected: []});
    };
    handleKeyDown = (event, id) => {
        if (keycode(event) === 'space') {
            this.handleClick(event, id);
        }
    };
    handleClick = (event, id) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);

        const showToolbar = props.showToolbar || false;
        const enableSelect = props.enableSelect || false;
        const orderBy = props.orderBy || Object.keys(props.columnData)[0];
        const orderType = props.orderType || 'asc';
        const showOrderCount = props.showOrderCount || false;

        this.state = {
            order: orderType,
            orderBy: orderBy,
            selected: [],
            columnData: this.props.columnData,
            data: this.props.data,
            showToolbar: showToolbar,
            enableSelect: enableSelect,
            showOrderCount: showOrderCount,
            page: 0,
            rowsPerPage: 5,
        };
    }

    componentWillReceiveProps(p) {
        this.setState({data: p.data});
    }

    render() {
        const {data, order, orderBy, selected, rowsPerPage, page, columnData, showToolbar, enableSelect, showOrderCount} = this.state;
        const {addFunc, editFunc, deleteFunc, detailFunc} = this.props;
        return (
            <div className="col-lg-12">
                {addFunc &&
                <div style={{paddingTop: 15}}>
                    <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                            style={{marginRight: 10}} onClick={addFunc}>
                        <i className="zmdi zmdi-plus zmdi-hc-fw"/>
                        <span>افزودن</span>
                    </Button>
                </div>
                }
                {
                    showToolbar && <DataTableToolbar numSelected={selected.length}/>
                }

                <div className="flex-auto">
                    <div className="table-responsive-material">

                        <Table>
                            <DataTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                rowCount={data.length}
                                columnData={columnData}
                                enableSelect={enableSelect}
                            />
                            <TableBody>
                                {data.length == 0 &&
                                <td className='text-center' colspan={columnData.length}
                                    style={{padding: 15, color: 'gray'}}> فاقد اطلاعات</td>
                                }
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                    const isSelected = this.isSelected(n.id);
                                    return (
                                        <TableRow
                                            hover
                                            onClick={event => this.handleClick(event, n.id)}
                                            onKeyDown={event => this.handleKeyDown(event, n.id)}
                                            tabIndex={-1}
                                            key={n.id}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            selected={isSelected}
                                        >
                                            {
                                                Object.values(n).map((x) => {
                                                    return (
                                                        <TableCell className='text-center'
                                                                   style={{padding: 0}}>{x}</TableCell>
                                                    );
                                                })
                                            }
                                            <TableCell
                                                padding="none"
                                                className="text-center">
                                                {(detailFunc) &&
                                                <Button variant="raised"
                                                        className="jr-btn bg-primary jr-btn-sm text-white"
                                                        style={{marginRight: 10}}
                                                        data-id={n.id}
                                                        data-extra={JSON.stringify(n)}
                                                        onClick={detailFunc}
                                                >
                                                    <i className="zmdi zmdi-assignment-o"/>
                                                    <span>جزئیات</span>
                                                </Button>
                                                }
                                                {(editFunc) &&
                                                <Button variant="raised"
                                                        className="jr-btn bg-cyan jr-btn-sm text-white"
                                                        style={{marginRight: 10}}
                                                        data-id={n.id}
                                                        data-extra={JSON.stringify(n)}
                                                        onClick={editFunc}
                                                >
                                                    <i className="zmdi zmdi-edit zmdi-hc-fw"/>
                                                    <span>ویرایش</span>
                                                </Button>
                                                }
                                                {(deleteFunc) &&
                                                <Button variant="raised"
                                                        onClick={deleteFunc}
                                                        className="jr-btn bg-red jr-btn-sm text-white"
                                                        data-id={n.id}
                                                        data-extra={JSON.stringify(n)}
                                                        style={{marginRight: 10}}>
                                                    <i className="zmdi zmdi-delete zmdi-hc-fw"/>
                                                    <span>حذف</span>
                                                </Button>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        count={data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                    />
                                </TableRow>
                                {showOrderCount &&
                                <TableRow>
                                    <div style={{flex: 1, justifyContent: 'flex-end'}}>
                                        <span>تعداد رکورد های یافت شده: {data.length}</span>
                                    </div>
                                </TableRow>
                                }

                            </TableFooter>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}


export default DataTable;


// WEBPACK FOOTER //
// ./components/customized/tables/datatable.js